






























import { Component, Vue } from "vue-property-decorator";

import { mapGetters } from "vuex";

@Component({
  data() {
    return {
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: "Campo obbligatorio",
            trigger: "blur",
          },
        ]
      },
    };
  },
  computed: {
    ...mapGetters("paymentmethods", ["paymentmethodsList"]),
    ...mapGetters(["inLoading"]),
  },
  created() {
    this.$store.dispatch("paymentmethods/getPaymentmethods");
  },
  methods: {
    save() {
      (
        this.$refs.form as Vue & {
          validate: (cb: (valid: boolean) => void) => void;
        }
      ).validate(async (valid: boolean) => {
        if (valid) {
          let action = "paymentmethods/createPaymentmethods";
          if (this.$data.form.id) {
            action = "paymentmethods/editPaymentmethods";
          }

          this.$store
            .dispatch(action, {
              ...this.$data.form,
            })
            .then((response) => {
              if (response.status == 201 || response.status == 200) {
                this.$store.dispatch("paymentmethods/getPaymentmethods");
                this.$data.form = {}
              }
              setTimeout(() => {
                this.$store.dispatch("paymentmethods/getPaymentmethods")
              }, 1000);
            });
        }
      });
    },
    editPaymentmethods(paymentmethods: any) {
      this.$store.dispatch("paymentmethods/editPaymentmethods", {
        ...paymentmethods,
      });
    },
  },
})
export default class SettingsPaymentmethods extends Vue { }
